import { FC } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { NO_BREAK_SPACE } from '../../../utils/constants';

const ErrorMessage: FC<PropTypes> = ({ fieldState }) => (
  <small className="p-error block mt-1">
    {fieldState.error?.message || NO_BREAK_SPACE}
  </small>
);

type PropTypes = {
  fieldState: ControllerFieldState;
};

export default ErrorMessage;
